
import { companyStore } from '@/store';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class CompanyParticularitiesView extends Vue {
  public loading = true;
  @Prop({ default: false }) readonly propFlat;
  @Prop({ default: true }) readonly propStyle;
  @Prop(String) readonly propC014_id;

  @Watch('propC014_id', { immediate: true })
  async update(val: number) {
    this.c014_id = val;
    await this.load();
  }

  public c014_id = 0;
  public particularidades = '';

  public async load() {
    this.loading = true;
    if (this.c014_id > 0) {
      this.particularidades = await companyStore.getParticularidades(this.c014_id);
    }
    this.loading = false;
  }
}
